export default __webpack_public_path__ + "static/letter-6a804369786b66e5375711fbb8677cf1.png";